import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {AppEventModel} from './AppEvent.model';

@injectable()
export class AppEventFactory
  implements BaseDomainFactory<AppEventModel, AppEventModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: AppEventModel.Props): AppEventModel {
    return this.modelsRegistry.put(new AppEventModel(props));
  }
}
